import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-heading font-semibold text-foreground-950 mb-4">
              色戒完整指南
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于为影迷提供《色戒》无删减版的全面资讯，包括版本对比、剧情解析、创作背景及正版高清资源获取指南。
            </p>
          </div>

          <div>
            <h4 className="text-base font-heading font-semibold text-foreground-950 mb-4">
              内容分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/plot-analysis" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">剧情解析</Link>
              <Link to="/category/version-comparison" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">版本对比</Link>
              <Link to="/category/creation-background" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">创作背景</Link>
              <Link to="/category/resource-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">资源指南</Link>
            </div>
          </div>

          <div>
            <h4 className="text-base font-heading font-semibold text-foreground-950 mb-4">
              热门文章
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/article/sejie-uncut-full-analysis" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">完整剧情解析</Link>
              <Link to="/article/sejie-cut-vs-uncut-comparison" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">删减版 vs 完整版</Link>
              <Link to="/article/sejie-hd-resource-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">高清资源获取攻略</Link>
              <Link to="/article/ang-lee-director-interview" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">李安导演访谈</Link>
            </div>
          </div>

          <div>
            <h4 className="text-base font-heading font-semibold text-foreground-950 mb-4">
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link>
              <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">联系我们</a>
              <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2025 色戒完整指南. 本站内容仅供影迷交流参考，不提供任何影片下载链接。
          </p>
          <p className="text-xs text-foreground-400">
            电影《色戒》版权归原制作公司所有
          </p>
        </div>
      </div>
    </footer>
  );
}